// src/components/HeroSection.js
import React, { useEffect, useRef, useState } from "react";
import "animate.css";

import img from "../../assets/img/hero-regent.webp";

const HeroSection = ({ scrollToConsult }) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          } else {
            setIsVisible(false); // Set to false when the section is not visible
          }
        });
      },
      { threshold: 0.1 } // Adjust the threshold as needed
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div
      className="container-fluid"
      style={{
        backgroundColor: "#F9F6F0",
      }}
    >
      <div
        className="row align-items-center px-lg-5"
        style={{ marginTop: "70px" }}
        ref={sectionRef}
      >
        <div className="col-lg-6">
          <img
            src={img}
            className={`img-fluid rounded-5 w-100 p-lg-4 ${
              isVisible
                ? "animate__animated animate__zoomIn"
                : "animate__animated animate__fadeOut"
            }`}
            alt="hero"
            srcSet={`${img} 600w, ${img} 1024w`}
            sizes="(max-width: 768px) 100vw, 50vw"
            fetchPriority="high"
          />
        </div>

        <div className="col-lg-6 px-lg-5 mb-3">
          <h1
            className={`text-dark fs-sm-48 mt-5 mt-lg-0 fw-800 ${
              isVisible
                ? "animate__animated animate__zoomIn"
                : "animate__animated animate__fadeOut"
            }`}
          >
            Get a stunning straight smile with{" "}
            <span className="text-golden">Invisalign® </span>
          </h1>
          <p
            className={`fs-17 fw-400 text-dark ${
              isVisible
                ? "animate__animated animate__zoomIn"
                : "animate__animated animate__fadeOut"
            }`}
          >
            Book a <span className="text-golden">FREE</span> Consultation with
            your leading Diamond Apex Invisalign® Practice
          </p>
          <ul
            className={`list-unstyled ${
              isVisible
                ? "animate__animated animate__zoomIn"
                : "animate__animated animate__fadeOut"
            }`}
          >
            <li>
              {" "}
              <p className="fs-17 fw-700">
                <i class="fa fa-check-circle-o me-2"></i>
                <span className="text-golden">20% </span> off your Invisalign®
                treatment
              </p>{" "}
            </li>
            <li>
              {" "}
              <p className="fs-17 fw-700">
                <i class="fa fa-check-circle-o me-2"></i>
                <span className="text-golden">FREE</span> 3D Scan (worth £75)
              </p>{" "}
            </li>
            <li>
              {" "}
              <p className="fs-17 fw-700">
                <i class="fa fa-check-circle-o me-2"></i>
                <span className="text-golden">FREE</span> Treatment Simulation
                (worth £300)
              </p>{" "}
            </li>
            <li>
              {" "}
              <p className="fs-17 fw-700">
                <i class="fa fa-check-circle-o me-2"></i>
                <span className="text-golden">FREE</span> Teeth Whitening (worth
                £295)
              </p>{" "}
            </li>
            <li>
              {" "}
              <p className="fs-17 fw-700">
                <i class="fa fa-check-circle-o me-2"></i>
                <span className="text-golden">FREE</span> Retainers (worth £400)
              </p>{" "}
            </li>
          </ul>
          <a
            className={`btn btn-theme fs-14 mb-4 ${
              isVisible
                ? "animate__animated animate__zoomIn"
                : "animate__animated animate__fadeOut"
            }`}
            onClick={scrollToConsult}
          >
            BOOK A FREE CONSULTATION
          </a>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
